var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "17",
        viewBox: "0 0 17 17",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_2640",
            "data-name": "Group 2640",
            transform: "translate(-1706 -162)",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Path_2259",
                "data-name": "Path 2259",
                fill: "#3699ff",
                transform: "translate(1706 162)",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M 8.5 16.5 C 4.088789939880371 16.5 0.5 12.91121006011963 0.5 8.5 C 0.5 4.088789939880371 4.088789939880371 0.5 8.5 0.5 C 12.91121006011963 0.5 16.5 4.088789939880371 16.5 8.5 C 16.5 12.91121006011963 12.91121006011963 16.5 8.5 16.5 Z",
                  stroke: "none",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M 8.5 1 C 4.364489555358887 1 1 4.364489555358887 1 8.5 C 1 12.6355094909668 4.364489555358887 16 8.5 16 C 12.6355094909668 16 16 12.6355094909668 16 8.5 C 16 4.364489555358887 12.6355094909668 1 8.5 1 M 8.5 0 C 13.19441986083984 0 17 3.805580139160156 17 8.5 C 17 13.19441986083984 13.19441986083984 17 8.5 17 C 3.805580139160156 17 0 13.19441986083984 0 8.5 C 0 3.805580139160156 3.805580139160156 0 8.5 0 Z",
                  fill: "#3699ff",
                  stroke: "none",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_2258",
              d: "M.828,0h1.68V-6.648H.828ZM1.68-7.44a.992.992,0,0,0,1.032-.984A.992.992,0,0,0,1.68-9.408a.985.985,0,0,0-1.032.984A.985.985,0,0,0,1.68-7.44Z",
              "data-name": "Path 2258",
              fill: "#fff",
              transform: "translate(1713 175)",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }